import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle, Fragment } from "react";
import {FormHelperText,
        FormControl,
        InputLabel,
        Input,
        Grid,
        InputAdornment,
        Chip,
        Select,
        MenuItem,
        Avatar,
        Badge,
        ListSubheader,
        TextField
} from "@material-ui/core";
import EmojiPeopleIcon from '@material-ui/icons/EmojiPeople';
import GroupIcon from '@material-ui/icons/Group';
import SearchIcon from "@material-ui/icons/Search";
import classnames from "classnames";
import useStyles from './styles';
import config from '../../config'
import ttAPI from '../../api/ttAPI';
import './SelectTechnicians.css'
import debounce from 'lodash.debounce';


const SelectTehnicians = forwardRef((props, ref) => {
//export default function CreateSite(props, ref) {
    // global
    // only need to use getIsInRegion for add job
    const { onFormUpdated, onTechniciansSelected, onLeaderSelected, getIsInRegion, showQualifiedTechWarning } = props
    const classes = useStyles();
    const formRef = useRef(null);

    const [newJob, setNewJob] = useState({...props.createdJob});
    const [selectedWorkers, setSelectedWorkers] = useState([]);
    const [noLeaderSelectedError, setNoLeaderSelectedError] = React.useState(false);
    const [leaderOptions, setLeaderOptions] = useState();
    const [selectedLeaderId, setSelectedLeaderId] = React.useState('');
    const [workerSelectionOpen, setWorkerSelectionOpen] = React.useState(false);
    const [leaderSelectionOpen, setLeaderSelectionOpen] = React.useState(false);
    const [technicianSettingsSetups, setTechnicianSettingsSetups] = useState([]);
    const [techSettingsComponents, setTechSettingsComponents] = useState();
    const containsText = (text, searchText) => text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
    const [searchWorkerText, setSearchWorkerText] = useState('');
    const [searchLeaderText, setSearchLeaderText] = useState('');
    const [displayedWorkersOptions, setDisplayedWorkersOptions] = useState([]);
    const delayedOnSearchWorkerText = useRef(debounce(q => setSearchWorkerText(q), 1)).current;
    const delayedOnSearchLeaderText = useRef(debounce(q => setSearchLeaderText(q), 1)).current;


    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
      PaperProps: {
        style: {
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          width: 250,
        },
      },
    };


    useImperativeHandle(ref, () => ({
      saveTechs() {
        formRef.current.dispatchEvent(new Event('submit'))
      },
      updateLeaderWokersSelection(isInRegion) {
        setNewJob({
          //...newJob,
          ...props.createdJob,
          is_in_region: isInRegion === 'YES'
        });
        refreshLeaderWorkersSelection();
      },
      updateTestingScopes(testingScopes) {
          if (testingScopes) {
            setNewJob(
              {
                //...newJob,
                ...props.createdJob,
                testing_scopes: testingScopes
              }
            );
          }
        }
    }));

    useEffect(() => {
        let mounted = true;

        async function fetchTechnicianSettingsSetups() {
            const response = await ttAPI.getTechnicianSettingsSetups();
            if (response !== undefined && response !== null) {
              if(mounted){
                  setTechnicianSettingsSetups(response);
              }
            }
        }

        fetchTechnicianSettingsSetups();
        return () => mounted = false;
    },[]);

    useEffect(() => {
        let mounted = true;

        setDisplayedWorkersOptions(props.workers.filter((worker) => containsText(worker.name, searchWorkerText)));

        return () => mounted = false;
    },[searchWorkerText]);

    useEffect(() => {
        var teamLeaderOptions = [];
        var techSettingComponentsTemp = [];
        //teamLeaderOptions.push(<MenuItem key="0" aria-label="None" value="">Click here to remove Leader</MenuItem>);
        var previousWorkerRegionId = -1;
        if (props.workers !== undefined && props.workers !== null && props.workers.length > 0) {
          props.workers.map(worker => {
              // setup settings icons for each worker
               if (worker.technician_settings !== undefined && worker.technician_settings !== null) {
                   Object.entries(worker.technician_settings).forEach(([key, value]) => {
                    var setting = technicianSettingsSetups.find(tss => tss.name === key && value);
                    if (setting !== undefined) {
                        var isInScope = setting.category === 'training' && newJob.testing_scopes !== undefined && newJob.testing_scopes !== null && newJob.testing_scopes.some(ts => ts === undefined || ts.name === undefined ? false : ts.name.split(' ')[0].toLowerCase() === setting.label.split(' ')[0].toLowerCase());
                        var settingComponent = (<Fragment key={`${setting.id}_${worker.id}`}>
                            &nbsp;  {key === 'suburb' ?  <span>({value.split(',').length <= 0 ? value : value.split(',')[0]})</span> :
                            <img style={{width:'25px', height:'25px'}} className={classnames({[classes.highlight]: isInScope})} src={`${config.hostApi}${config.portApi ? `:${config.portApi}` : ``}/client/tssp/${setting.id}`} alt={`${setting.label}`} title={`${setting.label}`}/>}
                        </Fragment>);

                        var existingSetting = techSettingComponentsTemp.find(x => x.id === worker.id);

                        if (existingSetting === undefined) {
                          if (key === 'suburb') {
                              // make sure suburb shows first
                              techSettingComponentsTemp.unshift({id: worker.id, settings: [settingComponent]})
                          }
                          else {
                              techSettingComponentsTemp.push({id: worker.id, settings: [settingComponent]});
                          }
                        }
                        else {
                          techSettingComponentsTemp = techSettingComponentsTemp.map(s =>
                            s.id === worker.id
                              ? { ...s, settings: [...s.settings, settingComponent]  }
                              : s
                          );
                        }
                    }
                  });
               }





              var canAddToLeaderList = false;
              if (searchLeaderText !== null && searchLeaderText !== undefined && searchLeaderText !== '') {
                  if (containsText(worker.name, searchLeaderText)) {
                      canAddToLeaderList = true;
                  }
              }
              else {
                  canAddToLeaderList = true;
              }

              if (!newJob.is_in_region &&
                  (previousWorkerRegionId === -1 || previousWorkerRegionId !== worker.franchise_id) &&
                  canAddToLeaderList) {
                teamLeaderOptions.push(<ListSubheader key={`franchise_${worker.franchise_id}`}
                                                      className={classes.stickyLeaderSubheader}>
                                                      <div className={classes.stickySubheaderContent} >
                                                      {worker.franchise_name}</div></ListSubheader>);
                previousWorkerRegionId = worker.franchise_id;
              }

              if (canAddToLeaderList) {
                  teamLeaderOptions.push(<MenuItem key={worker.id} value={worker.id} disabled={worker.id === parseInt(selectedLeaderId) || selectedWorkers.filter(item => item.id === worker.id).length === 1}>
                                      <Badge classes={{ badge: classes.customBadge }} overlap="circle" badgeContent={worker.level}>
                                        {getAvatar(`${worker.id}`, `${worker.proof_access}`)}
                                      </Badge>
                                      <span className="dropdown-avatar" style={{display: 'inline-flex', alignItems: 'center'}}><span>{worker.name}</span>
                                        {worker.technician_settings !== undefined && worker.technician_settings !== null &&
                                        <span style={{display: 'inline-flex', alignItems: 'center'}}>
                                            {techSettingComponentsTemp.length > 0 &&
                                                techSettingComponentsTemp.find(tsc => {return tsc.id === worker.id}) !== undefined &&
                                                techSettingComponentsTemp.find(tsc => {return tsc.id === worker.id}).settings}</span>}
                                      </span></MenuItem>)
                                    };

          });
          setLeaderOptions(teamLeaderOptions);
          setTechSettingsComponents(techSettingComponentsTemp);
          setDisplayedWorkersOptions(props.workers);
        }




    }, [props.workers, selectedLeaderId, selectedWorkers, newJob.is_in_region, newJob.franchise_id, props.dirty, technicianSettingsSetups, searchLeaderText]);

    useEffect(() => {
      if (newJob !== undefined && newJob !== null) {
        // for edit job
        if (newJob.id !== undefined && newJob.id > 0) {
          if (newJob.workers !== undefined && newJob.workers !== null && newJob.workers.length > 0) {
            setSelectedWorkers(newJob.workers);
            onTechniciansSelected(newJob.workers);
            const hasLeader = selectedLeaderId !== undefined && selectedLeaderId !== null && selectedLeaderId > 0;
            onFormUpdated(hasLeader);
            setNoLeaderSelectedError(!hasLeader);
          }

          if (newJob.leader !== undefined && newJob.leader !== null && newJob.leader > 0) {
              setSelectedLeaderId(newJob.leader.toString());
          }
        }
        else {
          if (newJob.leader === undefined || newJob.leader === null || newJob.leader <= 0 ||
              newJob.workers === undefined || newJob.workers === null || newJob.workers.length <= 0) {
             // you can save without selecting techs
             onFormUpdated(true);
             setNoLeaderSelectedError(false);
          }
          else {
            if (props.isAddJob) {
              refreshLeaderWorkersSelection();
            }
            else {
              setSelectedWorkers(newJob.workers);
              setSelectedLeaderId(newJob.leader.toString());
              onTechniciansSelected(newJob.workers);
              if (newJob.workers !== undefined && newJob.workers !== null && newJob.workers.length > 0) {
                  const hasLeader = selectedLeaderId !== undefined && selectedLeaderId !== null && selectedLeaderId > 0;
                  onFormUpdated(hasLeader);
                  setNoLeaderSelectedError(!hasLeader);
              }
              else {
                  onFormUpdated(true);
                  setNoLeaderSelectedError(false);
              }
            }
          }
        }
      }
    }, [newJob]);

    useEffect(() => {
      onTechniciansSelected(selectedWorkers);
      if (selectedWorkers !== undefined && selectedWorkers !== null && selectedWorkers.length > 0) {
          const hasLeader = selectedLeaderId !== undefined && selectedLeaderId !== null && selectedLeaderId > 0;
          onFormUpdated(hasLeader);
          setNoLeaderSelectedError(!hasLeader);
      }
    },[selectedWorkers]);

    useEffect(() => {
        if (selectedLeaderId !== undefined && selectedLeaderId !== null && selectedLeaderId > 0) {
            onLeaderSelected(parseInt(selectedLeaderId));
            onFormUpdated(true);
            setNoLeaderSelectedError(false);
        }
        else {
          // remove triggered
          onLeaderSelected(null);
          onFormUpdated(true);
          setNoLeaderSelectedError(false);
        }
    },[selectedLeaderId]);

    useEffect(() => {
      if (props.isAddJob)  {
          /*var stillContainsLeader = false;
           for (var i = 0; i < props.workers.length; i++) {
               if (props.workers[i].id === parseInt(selectedLeaderId === null || selectedLeaderId === undefined || selectedLeaderId === '' ? newJob.leader : selectedLeaderId)) {
                 stillContainsLeader = true;
                 break;
               }
           }
           if (!stillContainsLeader) {
             setSelectedLeaderId('');
           }
           var newJobWorkers = selectedWorkers === undefined || selectedWorkers === null || selectedWorkers.length <= 0 ? newJob.workers : selectedWorkers;
           newJobWorkers = newJobWorkers.filter(worker => props.workers.filter(item => item.id === worker.id).length === 1);
           setSelectedWorkers(newJobWorkers);*/

           setNewJob({
             ...newJob,
             is_in_region: getIsInRegion()
           });
        }
    },[]);

    function refreshLeaderWorkersSelection() {
      var stillContainsLeader = false;
      for (var i = 0; i < props.workers.length; i++) {
          if (props.workers[i].id === parseInt(selectedLeaderId)) {
            stillContainsLeader = true;
            break;
          }
      }
      if (!stillContainsLeader) {
        // TODO: this setSelectedLeaderId does not actually set the value, I am not sure why, thus the leader is still set on this component here
        // the good thing is it's the parent component holds the data and send it out, so not affecting saving...
        setSelectedLeaderId('-1');
        // it doesn't trigger the useEffect selectedLeaderId, manually trigger:
        onLeaderSelected(-1);
      }
      else {
        // it doesn't trigger the useEffect selectedLeaderId, manually trigger:
        onLeaderSelected(selectedLeaderId);
      }


      var newJobWorkers = selectedWorkers;
      newJobWorkers = newJobWorkers.filter(worker => props.workers.filter(item => item.id === worker.id).length === 1);
      setSelectedWorkers(newJobWorkers);
      onTechniciansSelected(newJobWorkers);
      if (newJobWorkers !== undefined && newJobWorkers !== null && newJobWorkers.length > 0) {
          const hasLeader = selectedLeaderId !== undefined && selectedLeaderId !== null && selectedLeaderId > 0;
          onFormUpdated(hasLeader);
          setNoLeaderSelectedError(!hasLeader);
      }
    }

    function handleChangeLeader(e) {
      if (e.target.value !== undefined) {
        setSelectedLeaderId(e.target.value);
        // remove leader from selected worker list
        setSelectedWorkers(selectedWorkers.filter(item => item.id !== parseInt(e.target.value)));
      }
    }

    function validateLeader() {
      // we allows no techncians selected as sometimes they just want to create a job first

      // if no worker is selected then there's no need to check leader selected
      if (selectedWorkers === undefined || selectedWorkers === null || selectedWorkers.length <= 0) {
          setNoLeaderSelectedError(false);
      }
      // if there are worker selected then a leader must be selected
      else {
          setNoLeaderSelectedError(selectedLeaderId === undefined || selectedLeaderId === null || selectedLeaderId <= 0);
      }
    }

    function validate(leader) {
        const errors = [];

        if (leader === undefined || leader === null || leader <= 0) {
            errors.push("You must select a team leader for the job.");
        }

        return errors;
    }


  async function handleSubmit (e) {
     const errors = validate(selectedLeaderId);
     if (errors.length > 0) {
         console.error('save select technicians has error');
         return;
     }
   }

    const handleChange = (event) => {
      if (event.target.value.filter(worker => worker === undefined).length <= 0) { // make sure user is not selecting a list title!
          setSelectedWorkers(event.target.value);

          if (event.target.value.filter(worker => worker.id === selectedLeaderId).length > 0) {
              setSelectedWorkers(event.target.value.filter(worker => worker.id !== selectedLeaderId));
          }
      }

    };

    const handleDelete = (id) => {
      const updatedWorkers = selectedWorkers.filter(item => item.id !== parseInt(id));
      setSelectedWorkers(updatedWorkers);
      if (updatedWorkers !== undefined && updatedWorkers !== null && updatedWorkers.length > 0) {
          const hasLeader = selectedLeaderId !== undefined && selectedLeaderId !== null && selectedLeaderId > 0;
          onFormUpdated(hasLeader);
          setNoLeaderSelectedError(!hasLeader);
      }
      else {
        onFormUpdated(true);
        setNoLeaderSelectedError(false);
      }

    };

  const getAvatar = (id, proofAccess) => {
    //return (<Avatar className={classnames({[classes.vaccinationDecoration]: proofAccess == 'true'})} src={`${config.hostApi}${config.portApi ? `:${config.portApi}` : ``}/client/aimages/${id}`}/>);
    return (<Avatar src={`${config.hostApi}${config.portApi ? `:${config.portApi}` : ``}/client/aimages/${id}`}/>);
  }

  const onMouseDown = e => {
    e.stopPropagation();
  };

  function onBlurLeaderSelection() {
    validateLeader();
    setLeaderSelectionOpen(false);
  }

  const getWorkerItemGroupTitle = (worker, index) => {
    var title;
    if (!newJob.is_in_region && (index === 0 || (props.workers.length - 1 >= index && props.workers[index - 1].franchise_id !== worker.franchise_id))) {
      title = <ListSubheader className={classes.stickySubheader}
                             key={worker.franchise_id} >
                             <div className={classes.stickySubheaderContent} >{worker.franchise_name}</div></ListSubheader>
    }

    return title;
  }


  return ( props.workers && props.workers.length >= 0 && leaderOptions && leaderOptions.length >= 0 &&
    <div className={classes.contentDiv}>

    {/*}<div>{`selectedLeaderId is ${selectedLeaderId}`}</div>*/}
    <form ref={formRef} onSubmit={handleSubmit}>

        <Grid container spacing={4}>
        <Grid item xs={12}>
          {showQualifiedTechWarning && (
            <div style={{
              color: '#f44336',
              marginBottom: 10,
              fontSize: '0.9rem',
              fontWeight: 500
            }}>
              ⚠ Qualified technician required (Level 3 or above recommended). This job includes RCD/LG/3PH assets.
            </div>
            )}
          <FormControl variant="outlined"
                        className={classnames(classes.leaderControl, {
                          [classes.error]: noLeaderSelectedError,
                          'leader-control': true
                        })}
                        style={{marginBottom: props.compact ? 10 : 20}}>
            <InputLabel id="leader-label">Team Leader<sup>*</sup></InputLabel>
            <div className={classnames(classes.leaderInput, {
                          [classes.error]: noLeaderSelectedError,
                          'leader-control-input': true
                        })}>
              <InputAdornment position="start">
                <EmojiPeopleIcon />
              </InputAdornment>
              <Select
                className={classes.leaderSelect}
                labelId="leader-label"
                id="leader"
                value={selectedLeaderId}
                onChange={handleChangeLeader}
                onBlur={onBlurLeaderSelection}
                open={leaderSelectionOpen}
                onClose={(e) => {
                  if (e.target.id !== 'leaderSearchField') {
                    setLeaderSelectionOpen(false); setSearchLeaderText('');
                  }
                  }}
                onOpen={() => {setLeaderSelectionOpen(true); setSearchLeaderText('');}}
                open={leaderSelectionOpen}
                size="small"
              >
              <ListSubheader className={classes.selectLeaderSearch}>
                <TextField
                  id="leaderSearchField"
                  size="small"
                  // Autofocus on textfield
                  autoFocus
                  placeholder="Type to search..."
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    )
                  }}
                  style={{marginBottom: '-10px'}}
                  onClick={() => setLeaderSelectionOpen(true)}
                  onChange={(e) => {delayedOnSearchLeaderText(e.target.value)}}
                  onKeyDown={(e) => {
                    if (e.key !== "Escape") {
                      // Prevents autoselecting item while typing (default Select behaviour)
                      e.stopPropagation();
                    }
                  }}
                />
                <MenuItem key="0" aria-label="None" value="" onClick={() => {setLeaderSelectionOpen(false); setSelectedLeaderId('');}}>Click here to remove Leader</MenuItem>
              </ListSubheader>
                 {leaderOptions}
              </Select>
            </div>
            {noLeaderSelectedError && <FormHelperText className={classes.error}>You must select a leader for the job!</FormHelperText>}
        </FormControl>

          <FormControl variant="outlined"
                       className={classnames(classes.workers, {
                        'workers-control': true
                      })}>
            <InputLabel id="workers-label">Workers</InputLabel>
            <div className={classnames(classes.workerInput, {
                          'workers-control-input': true
                        })}>
            <InputAdornment position="start">
              <GroupIcon />
            </InputAdornment>
            <Select
              labelId="workers-label"
              id="workers"
              multiple
              className={classes.workersSelect}
              value={selectedWorkers}
              onChange={handleChange}
              open={workerSelectionOpen}
              onClose={() => {setWorkerSelectionOpen(false);setSearchWorkerText('');}}
              onOpen={() => {setWorkerSelectionOpen(true);setSearchWorkerText('');}}
              input={<Input id="worker-chip" />}
              renderValue={(selected) => (
                <div className={classes.chips}>
                  {selected.map((value) => {
                    return (
                      <Fragment key={value.id}>
                          <Badge classes={{ badge: classes.customBadgeSmall }} overlap="circle" badgeContent={value.level} anchorOrigin={{
                              vertical: 'top',
                              horizontal: 'left',
                            }}>
                          <Chip label={value.name}
                                className={classes.chip}
                                onDelete={() => handleDelete(`${value.id}`)}
                                variant="outlined"
                                avatar={getAvatar(`${value.id}`, `${value.proof_access}`)}
                                onMouseDown={onMouseDown}/>
                        </Badge>
                        </Fragment>
                  );
                })}
                </div>
              )}
              MenuProps={MenuProps}
              size="small"
            >
            <ListSubheader className={classes.selectSearch}>
              <TextField
                size="small"
                // Autofocus on textfield
                autoFocus
                placeholder="Type to search..."
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  )
                }}
                style={{marginBottom: '-10px'}}
                onChange={(e) => {delayedOnSearchWorkerText(e.target.value)}}
                onKeyDown={(e) => {
                  if (e.key !== "Escape") {
                    // Prevents autoselecting item while typing (default Select behaviour)
                    e.stopPropagation();
                  }
                }}
              />
            </ListSubheader>

              {displayedWorkersOptions !== undefined && displayedWorkersOptions !== null &&
                displayedWorkersOptions.length > 0 &&
                displayedWorkersOptions.map((worker, index) => (
                     [getWorkerItemGroupTitle(worker,index),
                     <MenuItem key={worker.id} value={worker}
                        disabled={selectedWorkers.filter(item => item.id === worker.id).length === 1 || parseInt(selectedLeaderId) === worker.id}
                        onClick={() => {setWorkerSelectionOpen(false);}}>
                        <Badge classes={{ badge: classes.customBadge }} overlap="circle" badgeContent={worker.level}>
                          {getAvatar(`${worker.id}`, `${worker.proof_access}`)}
                        </Badge>
                        <span className="dropdown-avatar" style={{display: 'inline-flex', alignItems: 'center'}}>
                        <span>{worker.name}</span> &nbsp;
                        {worker.technician_settings !== undefined && worker.technician_settings !== null &&
                          <span>{techSettingsComponents.length > 1 &&
                                 techSettingsComponents.find(tsc => {return tsc.id === worker.id}) !== undefined &&
                                 techSettingsComponents.find(tsc => {return tsc.id === worker.id}).settings}</span>}
                        </span>
                     </MenuItem>]
              ))}
            </Select>
            </div>
          </FormControl>

          {/*<MUIDataTable
            title="Technician List"
            data={props.workers !== undefined ? props.workers.map(item => {
                return [
                    item.id,
                    item.name,
                    item.signon,
                    item.email
                ]
            }) : []}
            columns={columns}
            options={{
              filterType: 'multiselect',
              selectableRowsOnClick: true,
              download: false,
              print: false,
              customToolbarSelect: () => {},
              onRowsSelect : (curRowSelected, allRowsSelected) => {
                selectedWorkers = allRowsSelected.map(item => {
                  return props.workers[item.dataIndex].id;
                });
              }
            }}
          />*/}
        </Grid>
        </Grid>

      </form>
    </div>
  );
//}
});
export default SelectTehnicians;
